import { createElementBlock as o, openBlock as t, createElementVNode as l } from "vue";
import c from "./index289.js";
const n = {}, a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function r(s, e, m, f, i, p) {
  return t(), o("svg", a, e[0] || (e[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#F7F6EF",
        d: "M41.838 20.812c-1.256 0-2.437.246-3.471.735C37.592 16.712 33.159 13 27.84 13c-5.797 0-10.525 4.412-10.673 9.88C13.696 23.299 11 26.1 11 29.569c0 3.713 3.176 6.726 7.092 6.726h23.746c4.507 0 8.162-3.47 8.162-7.743s-3.655-7.74-8.162-7.74Z"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "m27.841 11.75-.301.004c-5.911.14-10.8 4.419-11.53 9.95l-.016.12-.232.061c-3.494.96-6.012 4.035-6.012 7.684 0 4.418 3.75 7.976 8.342 7.976h23.746c5.182 0 9.412-4.013 9.412-8.993 0-4.979-4.23-8.99-9.412-8.99l-.392.007a9.854 9.854 0 0 0-1.884.248l-.299.077-.073-.232c-1.533-4.628-6.094-7.912-11.349-7.912Zm0 2.5c4.666 0 8.608 3.23 9.292 7.494a1.25 1.25 0 0 0 1.648.982l.12-.05c.856-.404 1.853-.614 2.937-.614 3.83 0 6.912 2.922 6.912 6.49 0 3.569-3.082 6.493-6.912 6.493H18.092c-3.24 0-5.842-2.469-5.842-5.476 0-2.78 2.166-5.098 5.068-5.448a1.25 1.25 0 0 0 1.1-1.208c.129-4.789 4.303-8.663 9.423-8.663Zm-9.828 27.828a1.25 1.25 0 0 1 2.28 1.014l-.055.125-2.167 4.235a1.25 1.25 0 0 1-2.28-1.014l.055-.125 2.167-4.235Zm17.332 0a1.25 1.25 0 0 1 2.281 1.014l-.055.125-2.167 4.235a1.25 1.25 0 0 1-2.281-1.014l.055-.125 2.167-4.235Zm-8.666 2.118a1.25 1.25 0 0 1 2.281 1.014l-.056.125-2.167 4.234a1.25 1.25 0 0 1-2.28-1.014l.055-.124 2.167-4.235Zm16.25 0a1.25 1.25 0 0 1 2.281 1.014l-.055.124-1.083 2.118a1.25 1.25 0 0 1-2.282-1.013l.056-.125 1.083-2.118Z"
      })
    ], -1)
  ]));
}
const Z = /* @__PURE__ */ c(n, [["render", r]]);
export {
  Z as default
};
